import { render, staticRenderFns } from "./RescheduleAppointment.vue?vue&type=template&id=5875756e&"
import script from "./RescheduleAppointment.vue?vue&type=script&lang=js&"
export * from "./RescheduleAppointment.vue?vue&type=script&lang=js&"
import style0 from "./RescheduleAppointment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/katmar/Jenkins/workspace/QmaticWebBooking_1.4.x/QWB_Git_Frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VProgressCircular})
